import { FC, ReactNode, createContext, useContext, useState } from "react";
import { Profile, User } from "stubminer-logic/dist";

export interface ProfileContextInterface {
  profile: Profile | undefined;
  setProfile: (profile: Profile | undefined) => void;
  user: User | undefined;
  setUser: (user: User | undefined) => void;
}

interface ProfileContextProviderProps {
  children: ReactNode;
}

const notYetImplemented = () => {
  throw new Error(
    "ProfileContextProvider not yet implemented! Did you use the ProfileContextProvider component?"
  );
};

const defaultValue: ProfileContextInterface = {
  profile: undefined,
  setProfile: notYetImplemented,
  user: undefined,
  setUser: notYetImplemented,
};

export const ProfileContext =
  createContext<ProfileContextInterface>(defaultValue);

export const useProfileContext = () => useContext(ProfileContext);

export const ProfileContextProvider: FC<ProfileContextProviderProps> = ({
  children,
}) => {
  const [profile, setProfile] = useState<Profile | undefined>(undefined);
  const [user, setUser] = useState<User | undefined>(undefined);

  return (
    <ProfileContext.Provider
      value={{
        profile,
        setProfile,
        user,
        setUser,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};
